<div class="vtr-ui-snapshot-item-list">
	<vtr-ui-group-card class="snapshot-group-card-list col-12" [hostPage]="hostPage" [title]="title">
		<div class="snapshot-item" [ngClass]="{'separator':  i > 0}" *ngFor="let item of snapshotComponents; let i = index; let last = last">
			<vtr-ui-snapshot-item
				[name]='item.name'
				[component]="item.content"
				[componentType]="componentType"
				[componentIndex]="i">
				[isLastElement]="last"
			</vtr-ui-snapshot-item>
		</div>
	</vtr-ui-group-card>
</div>
